import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TitleWidth } from './translationUiConst';

class SolarInfo extends Component {
  render() {
    const {
      installationCnt = 0,
      installationCapacity = 0,
      moduleCnt = 0,
      t,
      i18n
    } = this.props;
    return (
      <TitleWrapper>
        <h4>{t('key187')}</h4>
        <CommonContainer>
          <TitleWithInfoContainer titleWidth={TitleWidth(i18n).title}>
            <span className='tit'>{t('key188')}</span>
            {/* 장 */}
            <span>{installationCnt}{t('key537')}</span>
            <div className='divider'/>
            <span>{installationCapacity}W</span>
          </TitleWithInfoContainer>
          <TitleWithInfoContainer titleWidth={TitleWidth(i18n).title}>
            <span className='tit'>{t('key188')}</span>
            {/* 대 */}
            <span>{moduleCnt}{t('key538')}</span>
          </TitleWithInfoContainer>
          <TitleWithInfoContainer titleWidth={TitleWidth(i18n).title}>
            <span className='tit'>{t('key189')}</span>
            {/* 용용아연 철 */}
            <span>{t('key539')}</span>
          </TitleWithInfoContainer>
          <TitleWithInfoContainer titleWidth={TitleWidth(i18n).title}>
            <span className='tit'>{t('key190')}</span>
            {/* 글자 */}
            <span>{t('key540')}</span>
          </TitleWithInfoContainer>
        </CommonContainer>
      </TitleWrapper>
    )
  }
}

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  & h4 {
    font-size: 18px;
    font-weight: 700;
    height: 28px;
    line-height: 28px;
    margin-bottom: 20px;
  }
`;

const CommonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px;
  gap: 10px;
  background-color: #F2F3F5;
  border-radius: 12px;
`;

const TitleWithInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;

  span {
    height: 28px;
    line-height: 28px;
  }
  .tit {
    ${({ titleWidth }) => titleWidth ? `width: ${titleWidth};` : 'width: 100px;'}
    font-weight: 600;
  }
  .sub {
    font-size: 13px;
    color: #797979;
  }
  .divider {
    border-left: 1px solid black;
    width: 1px;
    height: 12px;
  }
`;

export default withTranslation()(SolarInfo);